var _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwoSidesTask({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 44,
    height: 44,
    rx: 7,
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 3.5,
    width: 43,
    height: 43,
    rx: 6.5,
    stroke: "#C8C8CB"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 11.4788C36.7847 9.28496 33.9095 7.88038 30.8173 7.48139C27.7252 7.08241 24.5877 7.71115 21.888 9.27077C19.1884 10.8304 17.0764 13.2344 15.8774 16.1124M15 9.0931V16.1124H22.0193",
    stroke: "#005857",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 38.8836C17.2153 41.0774 20.0905 42.482 23.1827 42.881C26.2748 43.28 29.4123 42.6512 32.112 41.0916C34.8116 39.532 36.9236 37.128 38.1226 34.25M39 41.2693V34.25H31.9807",
    stroke: "#005857",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7363 24.9463C26.7363 25.9912 26.5557 26.9092 26.1943 27.7002C25.833 28.4863 25.3154 29.0918 24.6416 29.5166C23.9727 29.9365 23.2012 30.1465 22.3271 30.1465C21.4629 30.1465 20.6914 29.9365 20.0127 29.5166C19.3389 29.0918 18.8164 28.4888 18.4453 27.7075C18.0791 26.9263 17.8936 26.0254 17.8887 25.0049V24.4043C17.8887 23.3643 18.0718 22.4463 18.438 21.6504C18.8091 20.8545 19.3291 20.2466 19.998 19.8267C20.6719 19.4019 21.4434 19.1895 22.3125 19.1895C23.1816 19.1895 23.9507 19.3994 24.6196 19.8193C25.2935 20.2344 25.8135 20.835 26.1797 21.6211C26.5459 22.4023 26.7314 23.313 26.7363 24.353V24.9463ZM24.8833 24.3896C24.8833 23.208 24.6587 22.3022 24.2095 21.6724C23.7651 21.0425 23.1328 20.7275 22.3125 20.7275C21.5117 20.7275 20.8843 21.0425 20.4302 21.6724C19.981 22.2974 19.7515 23.1836 19.7417 24.3311V24.9463C19.7417 26.1182 19.9688 27.0239 20.4229 27.6636C20.8818 28.3032 21.5166 28.623 22.3271 28.623C23.1475 28.623 23.7773 28.3105 24.2168 27.6855C24.6611 27.0605 24.8833 26.1475 24.8833 24.9463V24.3896ZM32.5005 25.8911H30.4351V30H28.582V19.3359H32.332C33.5625 19.3359 34.5122 19.6118 35.1812 20.1636C35.8501 20.7153 36.1846 21.5137 36.1846 22.5586C36.1846 23.2715 36.0112 23.8696 35.6646 24.353C35.3228 24.8315 34.8442 25.2002 34.229 25.459L36.624 29.9048V30H34.6392L32.5005 25.8911ZM30.4351 24.4043H32.3394C32.9644 24.4043 33.4526 24.248 33.8042 23.9355C34.1558 23.6182 34.3315 23.186 34.3315 22.6392C34.3315 22.0679 34.168 21.626 33.8408 21.3135C33.5186 21.001 33.0352 20.8398 32.3906 20.8301H30.4351V24.4043Z",
    fill: "#005857"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di",
    x: 0,
    y: 0,
    width: 54,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 27,
    y1: 3,
    x2: 27,
    y2: 47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2F2F1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoSidesTask);
export default __webpack_public_path__ + "static/media/TwoSidesTask.a6eba102.svg";
export { ForwardRef as ReactComponent };